<template><div><h2 id="usage" tabindex="-1" class="d-docsite--header-2">Usage <a class="header-anchor d-link d-docsite--link d-link" href="#usage" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-bgr-{n}</code> to how an element's background image repeats.</p>
<code-example custom class="d-d-grid d-g-200 d-g-cols4 d-p-200 d-bgc-secondary" source-code='&lt;dt-stack align=&quot;center&quot; class=&quot;d-g-50&quot;&gt;
  &lt;div class=&quot;d-size-200 d-bgc-moderate d-bar-400 d-of-hidden d-bgp-tl d-bgs-var d-bgr-repeat&quot; style=&quot;--bgg-size: 65% 65%; background-image: url(&#39;/assets/images/puffin.jpg&#39;);&quot;&gt;&lt;/div&gt;
  &lt;dt-text as=&quot;code&quot; kind=&quot;code&quot; size=&quot;100&quot;&gt;d-bgr-repeat&lt;/dt-text&gt;
&lt;/dt-stack&gt;
&lt;dt-stack align=&quot;center&quot; class=&quot;d-g-50&quot;&gt;
  &lt;div class=&quot;d-size-200 d-bgc-moderate d-bar-400 d-of-hidden d-bgp-tl d-bgs-var d-bgr-repeat-x&quot; style=&quot;--bgg-size: 65% 65%; background-image: url(&#39;/assets/images/puffin.jpg&#39;);&quot;&gt;&lt;/div&gt;
  &lt;dt-text as=&quot;code&quot; kind=&quot;code&quot; size=&quot;100&quot;&gt;d-bgr-repeat-x&lt;/dt-text&gt;
&lt;/dt-stack&gt;
&lt;dt-stack align=&quot;center&quot; class=&quot;d-g-50&quot;&gt;
  &lt;div class=&quot;d-size-200 d-bgc-moderate d-bar-400 d-of-hidden d-bgp-tl d-bgs-var d-bgr-repeat-y&quot; style=&quot;--bgg-size: 65% 65%; background-image: url(&#39;/assets/images/puffin.jpg&#39;);&quot;&gt;&lt;/div&gt;
  &lt;dt-text as=&quot;code&quot; kind=&quot;code&quot; size=&quot;100&quot;&gt;d-bgr-repeat-y&lt;/dt-text&gt;
&lt;/dt-stack&gt;
&lt;dt-stack align=&quot;center&quot; class=&quot;d-g-50&quot;&gt;
  &lt;div class=&quot;d-size-200 d-bgc-moderate d-bar-400 d-of-hidden d-bgp-tl d-bgs-var d-bgr-space&quot; style=&quot;--bgg-size: 65% 65%; background-image: url(&#39;/assets/images/puffin.jpg&#39;);&quot;&gt;&lt;/div&gt;
  &lt;dt-text as=&quot;code&quot; kind=&quot;code&quot; size=&quot;100&quot;&gt;d-bgr-space&lt;/dt-text&gt;
&lt;/dt-stack&gt;
&lt;dt-stack align=&quot;center&quot; class=&quot;d-g-50&quot;&gt;
  &lt;div class=&quot;d-size-200 d-bgc-moderate d-bar-400 d-of-hidden d-bgp-tl d-bgs-var d-bgr-none&quot; style=&quot;--bgg-size: 65% 65%; background-image: url(&#39;/assets/images/puffin.jpg&#39;);&quot;&gt;&lt;/div&gt;
  &lt;dt-text as=&quot;code&quot; kind=&quot;code&quot; size=&quot;100&quot;&gt;d-bgr-none&lt;/dt-text&gt;
&lt;/dt-stack&gt;
&lt;dt-stack align=&quot;center&quot; class=&quot;d-g-50&quot;&gt;
  &lt;div class=&quot;d-size-200 d-bgc-moderate d-bar-400 d-of-hidden d-bgp-tl d-bgs-var d-bgr-unset&quot; style=&quot;--bgg-size: 65% 65%; background-image: url(&#39;/assets/images/puffin.jpg&#39;);&quot;&gt;&lt;/div&gt;
  &lt;dt-text as=&quot;code&quot; kind=&quot;code&quot; size=&quot;100&quot;&gt;d-bgr-unset&lt;/dt-text&gt;
&lt;/dt-stack&gt;'>
<dt-stack align="center" class="d-g-50">
  <div class="d-size-200 d-bgc-moderate d-bar-400 d-of-hidden d-bgp-tl d-bgs-var d-bgr-repeat" style="--bgg-size: 65% 65%; background-image: url('/assets/images/puffin.jpg');"></div>
  <dt-text as="code" kind="code" size="100">d-bgr-repeat</dt-text>
</dt-stack>
<dt-stack align="center" class="d-g-50">
  <div class="d-size-200 d-bgc-moderate d-bar-400 d-of-hidden d-bgp-tl d-bgs-var d-bgr-repeat-x" style="--bgg-size: 65% 65%; background-image: url('/assets/images/puffin.jpg');"></div>
  <dt-text as="code" kind="code" size="100">d-bgr-repeat-x</dt-text>
</dt-stack>
<dt-stack align="center" class="d-g-50">
  <div class="d-size-200 d-bgc-moderate d-bar-400 d-of-hidden d-bgp-tl d-bgs-var d-bgr-repeat-y" style="--bgg-size: 65% 65%; background-image: url('/assets/images/puffin.jpg');"></div>
  <dt-text as="code" kind="code" size="100">d-bgr-repeat-y</dt-text>
</dt-stack>
<dt-stack align="center" class="d-g-50">
  <div class="d-size-200 d-bgc-moderate d-bar-400 d-of-hidden d-bgp-tl d-bgs-var d-bgr-space" style="--bgg-size: 65% 65%; background-image: url('/assets/images/puffin.jpg');"></div>
  <dt-text as="code" kind="code" size="100">d-bgr-space</dt-text>
</dt-stack>
<dt-stack align="center" class="d-g-50">
  <div class="d-size-200 d-bgc-moderate d-bar-400 d-of-hidden d-bgp-tl d-bgs-var d-bgr-none" style="--bgg-size: 65% 65%; background-image: url('/assets/images/puffin.jpg');"></div>
  <dt-text as="code" kind="code" size="100">d-bgr-none</dt-text>
</dt-stack>
<dt-stack align="center" class="d-g-50">
  <div class="d-size-200 d-bgc-moderate d-bar-400 d-of-hidden d-bgp-tl d-bgs-var d-bgr-unset" style="--bgg-size: 65% 65%; background-image: url('/assets/images/puffin.jpg');"></div>
  <dt-text as="code" kind="code" size="100">d-bgr-unset</dt-text>
</dt-stack>
</code-example>
<h2 id="classes" tabindex="-1" class="d-docsite--header-2">Classes <a class="header-anchor d-link d-docsite--link d-link" href="#classes" aria-hidden="true">#</a></h2>
<utility-class-table>
  <template #content>
    <tbody>
      <tr v-for="i in repeat">
          <th scope="row" class="d-code--sm d-docsite-code">.d-bgr-{{ i }}</th>
          <td class="d-code--sm">
            background-repeat: {{ i }} !important;
          </td>
      </tr>
    </tbody>
  </template>
</utility-class-table>
</div></template>


<script setup>
const repeat = ['repeat', 'repeat-x', 'repeat-y', 'space', 'none', 'unset'];
</script>